import _Edit from "@mui/icons-material/Edit";
import React from 'react';
import { IconButton } from '@mui/material';
import styled from 'styled-components';
import { useSoftTickerContext } from 'app/hooks/useSoftTickerContext';
import { openUpdateScorer } from 'app/actions/softTickerActions';
const Wrapper = styled.div.withConfig({
  componentId: "sc-1uykn6w-0"
})(["align-self:flex-start;"]);
export default function EditScorerButton(_ref) {
  let {
    initData,
    matchEventId
  } = _ref;
  const {
    dispatch
  } = useSoftTickerContext();
  const handleClick = () => dispatch(openUpdateScorer({
    scorerData: initData,
    id: matchEventId
  }));
  return /*#__PURE__*/React.createElement(Wrapper, {
    "data-sentry-element": "Wrapper",
    "data-sentry-component": "EditScorerButton",
    "data-sentry-source-file": "EditScorerButton.tsx"
  }, /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    onClick: handleClick,
    "data-sentry-element": "IconButton",
    "data-sentry-source-file": "EditScorerButton.tsx"
  }, /*#__PURE__*/React.createElement(_Edit, {
    color: "action",
    "data-sentry-element": "Edit",
    "data-sentry-source-file": "EditScorerButton.tsx"
  })));
}